import { Component } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import { ToastrService } from 'toastr-ng2';
const swal = require('sweetalert');

@Component({
  selector: 'app-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss']
})
export class TagsComponent{

     tags:Array<any>;
     tagsData: FirebaseListObservable<any>;
    constructor(public af:AngularFireDatabase, public router:Router,public toastr: ToastrService) {
     this.tagsData = af.list('/tags');
     this.tagsData.subscribe((res)=>{
         this.tags = res;
     });
       
    }
   tagEdit(key){
    this.router.navigate(['/tags/editTags', key]);
  }

  tagDelete(key:any){
    swal({
            title: 'Are you sure?',
            text: 'Your will not be able to recover this data!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            closeOnConfirm: false,
            closeOnCancel: false
        }, (isConfirm) => {
            if (isConfirm) {
               this.tagsData.remove(key).then((res)=>{
                   swal('Deleted!','Tag Deleted Successfully!', 'success');
                 })
              } else {
                swal('Cancelled', 'Your data is safe :)', 'error');
            }
        });
  }

}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/routes/restaurant/tags/tags.component.ts